var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Editor',{attrs:{"image-provider":_vm.imageProvider,"width":_vm.width},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_c('pre',[_vm._v(_vm._s(_vm.data))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }